import { useTranslation } from 'react-i18next';
import ScrollReveal from '@/components/base/ScrollReveal';

const AUDIENCES = [
  { key: 'ideal1', icon: 'ri-building-2-line' },
  { key: 'ideal2', icon: 'ri-user-star-line' },
  { key: 'ideal3', icon: 'ri-shopping-cart-2-line' },
  { key: 'ideal4', icon: 'ri-briefcase-4-line' },
  { key: 'ideal5', icon: 'ri-home-6-line' },
  { key: 'ideal6', icon: 'ri-heart-pulse-line' },
  { key: 'ideal7', icon: 'ri-restaurant-2-line' },
  { key: 'ideal8', icon: 'ri-book-open-line' },
  { key: 'ideal9', icon: 'ri-building-line' },
];

export default function IdealFor() {
  const { t } = useTranslation();

  return (
    <section className="py-20 md:py-32 bg-[#F7F8FA]">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <ScrollReveal>
          <div className="text-center mb-16">
            <span className="inline-block px-4 py-1.5 rounded-full bg-white text-[#E53935] text-xs font-semibold tracking-wider uppercase mb-5 border border-gray-100">
              {t('trafficMaster.idealTag')}
            </span>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-[#111111] leading-tight">
              {t('trafficMaster.idealTitle')}
            </h2>
          </div>
        </ScrollReveal>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
          {AUDIENCES.map((aud, i) => (
            <ScrollReveal key={aud.key} delay={i * 0.06}>
              <div className="group bg-white rounded-2xl p-6 border border-gray-100 hover:border-[#C8A24A]/30 hover:shadow-[0_8px_40px_rgba(0,0,0,0.05)] transition-all duration-400 flex flex-col items-center text-center cursor-pointer h-full">
                <div className="w-12 h-12 rounded-xl bg-[#C8A24A]/5 flex items-center justify-center mb-4 group-hover:bg-[#C8A24A]/10 transition-colors duration-300">
                  <i className={`${aud.icon} text-[#C8A24A] text-xl`}></i>
                </div>
                <span className="text-[#111111] text-sm font-semibold">
                  {t(`trafficMaster.${aud.key}`)}
                </span>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}